import { ComplianceFormsApiBase } from './paymentApi';

class ComplianceFormsApi extends ComplianceFormsApiBase {

}

export default new ComplianceFormsApi();